import { $_user_role as Role } from '@/common/UserUtils'

export let DrawerItems = [
  {
    name: 'Рабочий календарь',
    path: '/calendar',
    icon: 'twotone-event_note-24px.png',
    requiredRoles: [Role.judge, Role.judgeHelper, Role.limitjudge],
  },
  // Судья
  {
    name: 'Мои дела',
    path: '/case',
    icon: 'twotone-work-24px.png',
    requiredRoles: [Role.judge, Role.judgeHelper, Role.limitjudge],
  },
  {
    name: 'Мои файлы',
    path: '/files',
    icon: 'twotone-cloud_circle-24px.png',
    requiredRoles: [Role.judge, Role.judgeHelper],
  },
  // База знаний
  {
    name: 'База знаний',
    path: '/knowledgebase',
    icon: 'twotone-cloud_circle-24px.png',
    requiredRoles: [Role.judge, Role.judgeHelper, Role.knowledge],
  },
  {
    name: 'Документы на подпись',
    path: '/signature',
    icon: 'twotone-create-24px.png',
    requiredRoles: [Role.judge, Role.judgeHelper],
  },
  {
    name: 'Постановления',
    path: '/ordinances',
    icon: 'twotone-create-24px.png',
    requiredRoles: [Role.judge],
    limitMenuKey: 'gsu',
  },
  {
    name: 'Статистика',
    path: '/gsustat',
    icon: 'twotone-import_contacts-24px.png',
    requiredRoles: [Role.admin],
    limitMenuKey: 'gsu',
  },
  // Почта
  {
    name: 'Почтовые отправления',
    path: '/post/letters',
    icon: 'twotone-mail-24px.png',
    requiredRoles: [Role.judge, Role.judgeHelper, Role.postworker],
  },
  {
    name: 'Почтовые реестры',
    path: '/post/registers',
    icon: 'twotone-import_contacts-24px.png',
    requiredRoles: [Role.postworker],
  },
  // Бухгалтер
  {
    name: 'Заявки на оплату',
    path: '/specialist/apps',
    icon: 'twotone-account_balance-24px.png',
    requiredRoles: [Role.judge, Role.accountant],
  },
  {
    name: 'Счета на оплату',
    path: '/specialist/reestr',
    icon: 'twotone-account_balance-24px.png',
    requiredRoles: [Role.accountant, Role.headofdepartment],
  },
  // Разработчик
  {
    name: '(ТЕСТ) Распределение',
    icon: 'twotone-account_balance-24px.png',
    requiredRoles: [Role.developer],
    items: [
      { name: 'Распределение', path: '/admin/distribtest' },
    ]
  },
  // Распределение
  {
    name: 'Распределение',
    icon: 'twotone-account_balance-24px.png',
    requiredRoles: [Role.admin, Role.chairman, Role.distributionOperator.administrative, Role.distributionOperator.civil, Role.distributionOperator.criminal],
    items: [
      { name: 'Материалы для распределения', path: '/admin/distribution', requiredRoles: [Role.chairman, Role.distributionOperator.administrative, Role.distributionOperator.civil, Role.distributionOperator.criminal] },
      { name: 'Распределенные материалы', path: '/admin/distributed', requiredRoles: [Role.chairman, Role.distributionOperator.administrative, Role.distributionOperator.civil, Role.distributionOperator.criminal] },
      { name: 'История дел', path: '/admin/history', requiredRoles: [Role.admin, Role.chairman] },
      { name: 'Категория-судья', path: '/admin/statistic', requiredRoles: [Role.admin, Role.chairman] },
      { name: 'Реестр судей', path: '/admin/judges', requiredRoles: [Role.admin, Role.chairman] },
    ]
  },
  // Управление
  {
    name: 'Управление',
    icon: 'twotone-account_balance-24px.png',
    requiredRoles: [Role.admin],
    noLimitMenuItem: true,
    items: [
      { name: 'Категории', path: '/admin/categories', },
      { name: 'Составы', path: '/admin/group', },
      { name: 'Реестр судей', path: '/admin/judges', },
      { name: 'Пользователи', path: '/admin/users', },
      { name: 'Суд', path: '/admin/court', },
      { name: 'Управление запросами', path: '/admin/datarequests', },
      { name: 'Модерация специалистов', path: '/specialist/list', requiredRoles: [Role.admin, Role.chairman] },
      { name: 'Экспертиза', path: '/admin/expert' },
      { name: 'Лог заявок на внесение денежных средств', path: '/admin/qrcode/logs' }
    ]
  },
  // Адвокат
  {
    name: 'Адвокаты Заявки',
    path: '/specialist/advocat/apps',
    icon: 'twotone-account_balance-24px.png',
    requiredRoles: [Role.specialist],
    specialistType: 0,
  },
  {
    name: 'Профиль',
    path: '/specialist/profile',
    icon: 'twotone_people_white_24dp.png',
    requiredRoles: [Role.specialist],
    specialistType: 0,
  },
  // Переводчик
  {
    name: 'Переводчики Заявки',
    path: '/specialist/translator/apps',
    icon: 'twotone-account_balance-24px.png',
    requiredRoles: [Role.specialist],
    specialistType: 1,
  },
  {
    name: 'Профиль',
    path: '/specialist/profile',
    icon: 'twotone_people_white_24dp.png',
    requiredRoles: [Role.specialist],
    specialistType: 1,
  },
]